document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-4)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2,
                },
            }
        });
    }());

    document.querySelector('.JS-show-map').addEventListener('click', function() {
        document.querySelector('[data-tabs] [aria-controls="mapa"]').click();
    });
});